import React, { useEffect, useState } from "react";
import { api } from "../../lib/apiClient";
import { History } from "lucide-react";

const fmtTiers = (tiers) =>
  (tiers || [])
    .map((t) => `${t.max_amount == null ? "above" : `≤£${Number(t.max_amount).toLocaleString("en-GB")}`} ${t.percent}%`)
    .join(" · ") || "none";

const FIELDS = [
  ["contingency_sundry_tiers", "Contingency Sundry", fmtTiers],
  ["administration_tiers", "Administration Charge", fmtTiers],
  ["admin_on_labour_only", "Admin on Labour Only", (v) => (v === false ? "Off" : "On")],
];

const Change = ({ entry, field: [key, label, fmt] }) => {
  const before = entry.before ? fmt(entry.before[key]) : null;
  const after = fmt(entry.after[key]);
  if (before === after) return null;
  return (
    <div className="text-xs font-mono">
      <span className="text-slate-500 font-sans font-semibold">{label}: </span>
      {before != null && <span className="text-red-600 line-through mr-2">{before}</span>}
      <span className="text-emerald-700">{after}</span>
    </div>
  );
};

export function RuleChangeHistory({ refreshKey }) {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/extra-cost-rules/history").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, [refreshKey]);

  return (
    <div className="border border-slate-200 p-4 space-y-3 max-w-4xl" data-testid="rule-change-history">
      <h3 className="font-display text-lg font-black tracking-tight inline-flex items-center gap-2">
        <History size={16} /> Change history
      </h3>
      {items == null && <div className="text-sm text-slate-500">Loading…</div>}
      {items?.length === 0 && <div className="text-sm text-slate-500" data-testid="rule-history-empty">No changes recorded yet.</div>}
      <ul className="divide-y divide-slate-200">
        {items?.map((e) => (
          <li key={e.id} className="py-3 space-y-1" data-testid={`rule-history-entry-${e.id}`}>
            <div className="text-sm">
              <span className={`font-semibold ${e.is_system ? "text-amber-700" : "text-slate-900"}`} data-testid="rule-history-who">
                {e.changed_by_name}
              </span>
              <span className="text-slate-500 ml-2" data-testid="rule-history-when">
                {new Date(e.changed_at).toLocaleString("en-GB")}
              </span>
              {e.note && <span className="text-slate-500 ml-2 italic">— {e.note}</span>}
            </div>
            {FIELDS.map((f) => <Change key={f[0]} entry={e} field={f} />)}
          </li>
        ))}
      </ul>
    </div>
  );
}
